import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  BellIcon,
  ArrowLeftIcon,
  CogIcon,
  WrenchScrewdriverIcon
} from '@heroicons/react/24/outline';

const NotificationSettings = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* 헤더 */}
      <div className="bg-white/80 backdrop-blur-md sticky top-0 z-40 border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center space-x-3">
              <button
                onClick={() => navigate('/profile')}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <ArrowLeftIcon className="h-5 w-5 text-gray-600" />
              </button>
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <div className="absolute inset-0 bg-blue-600 rounded-lg blur-md opacity-20"></div>
                  <div className="relative bg-gradient-to-br from-blue-500 to-blue-600 p-2 rounded-lg shadow-lg">
                    <BellIcon className="h-5 w-5 text-white" />
                  </div>
                </div>
                <div>
                  <h1 className="text-lg font-bold text-gray-900 tracking-tight">
                    알림 설정
                  </h1>
                  <p className="text-xs text-gray-600 -mt-0.5">
                    알림 수신 방법 설정
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 컨텐츠 */}
      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-8 text-center">
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-gray-200 rounded-full blur-2xl opacity-30"></div>
            <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-full p-8 shadow-inner">
              <div className="relative">
                <WrenchScrewdriverIcon className="h-16 w-16 text-gray-500" />
                <CogIcon className="absolute -bottom-2 -right-2 h-8 w-8 text-gray-600 animate-spin" style={{ animationDuration: '8s' }} />
              </div>
            </div>
          </div>

          <h2 className="mt-8 text-2xl font-bold text-gray-900">
            준비 중입니다
          </h2>
          
          <p className="mt-4 text-gray-600 leading-relaxed">
            알림 설정 기능을 준비하고 있습니다.<br />
            더 나은 서비스를 제공하기 위해 열심히 개발 중이니<br />
            조금만 기다려주세요!
          </p>

          <div className="mt-8 space-y-3">
            <div className="bg-blue-50 rounded-xl p-4">
              <h3 className="font-semibold text-blue-900 mb-2">
                곧 만나보실 수 있는 기능
              </h3>
              <ul className="text-sm text-blue-700 space-y-1 text-left">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>프로젝트 상태 변경 알림</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>새 메시지 알림</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>중요 공지사항 알림</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>SMS, 이메일, 푸시 알림 설정</span>
                </li>
              </ul>
            </div>
          </div>

          <button
            onClick={() => navigate('/profile')}
            className="mt-8 px-6 py-3 bg-gray-900 text-white rounded-xl font-medium hover:bg-gray-800 transition-colors"
          >
            돌아가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;